import { UIElementProps } from 'types/prop-types';

export default function Box({ children, className, ...props }: UIElementProps) {
  return (
    <div
      className={`relative border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] p-4 lg:p-8 ${
        className || ''
      }`}
    >
      {children}
    </div>
  );
}
